<div *ngIf="condition">
  <div class="d-flex justify-content-center " *ngIf="validatePaymentSuccess">
    <div>
      <h2 class="red-text text-center title-recharge mb-4">La recarga fue <b>exitosa</b>
        <img src="../../../../assets/images/claro-lines.png" class="img" alt="claro lines icon">
      </h2>
      <div class="gray-box">
        <div>
          <div>
            <h4><b>Resumen de Cambio</b></h4>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col styled-text"><p class="m-0">Numero de Telefono</p></div>
          <div class="col text-right"><p class="m-0"><b>{{ phoneNumber }}</b></p></div>
        </div>
        <div class="row mb-4">
          <div class="col styled-text"><p class="m-0">Fecha</p></div>
          <div class="col text-right"><p class="m-0"><b>{{ date }}</b></p></div>
        </div>
        <div class="text-center">
          <p class="m-0"><b>Monto</b></p>
          <h2 class="red-text"><b>{{ valueRecharged|currency }}</b></h2>
        </div>
      </div>
      <div class="d-flex justify-content-center flex-column align-items-center mt-4 mb-5" (click)="continue()">
        <button class="button-to-continue">
          Continuar <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center" *ngIf="refundView">
    <div class="text-center">
      <h2 class="title-recharge">Aviso <img src="../../../../assets/images/claro-lines.png" class="img" alt=""></h2>
      <p>Estimado cliente al momento estamos presentando problemas para activacion de su nuevo plan.</p>
      <p class="m-0"><b>El balance de su recarga y los cargos asociados a su pago se encuentran en proceso de devolucion.</b></p>
      <p class="mb-4">Por favor verifique en las proximas horas.</p>
      <div class="d-flex justify-content-center mb-5">
        <button class="button-ok" (click)="return()">
          Ok
        </button>
      </div>
    </div>
  </div>
</div>
